
// import { linkBuilder } from "@/utils";
import { setAttributeToElements } from "~/utils";

export default {
  name: "ResultProductCard",
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    dataAvailable() {
      return this.data?.mixedTranslation?.title || this.data?.title;
    },
    productLink() {
      return this.localePath({ path: `/product/${this.data.slug}`, query: { configuration_id: this.data?.configuration_id  } });
    },
  },
  watch: {
    dataAvailable: {
      handler(val) {
        if (val) {
          setAttributeToElements("a.hidden-ssr-link", "tabindex", "0");
        }
      },
    },
  },
  // methods: {
  //   linkBuilder,
  // },
};
